import { useCallback } from 'react'
import { isEmbedded, useParentPostMessage } from '@yes.technology/react-toolkit'
import { ActionButtonActionData } from 'types/shared'
import useInterpolateUrl from 'modules/interaction/hooks/useInterpolateUrl'

const useActionButtonNavigation = () => {
  const interpolateUrl = useInterpolateUrl()

  const { postMessage } = useParentPostMessage()

  const navigateToUrl = useCallback(
    (actionData: ActionButtonActionData) => {
      const interpolatedUrl = interpolateUrl(actionData.url)

      if (actionData.open_in_new_tab) {
        window.open(interpolatedUrl, '_blank', 'noopener,noreferrer')
        return
      }

      if (interpolatedUrl) {
        if (isEmbedded()) {
          postMessage({ type: 'redirect', url: interpolatedUrl })
        } else {
          window.location.href = interpolatedUrl
        }
      }
    },
    [interpolateUrl, postMessage]
  )

  return {
    interpolateUrl,
    navigateToUrl
  }
}

export default useActionButtonNavigation
